import { createFileRoute, redirect } from "@tanstack/react-router";
import { brandOnlyTarget } from "@/utils/carsBrandRedirect";

// Legacy list address with no server-rendered listings: 301 to the main
// passenger-car page, keeping any filters in the query string.
export const Route = createFileRoute("/masini/")({
  beforeLoad: ({ location }) => {
    const direct = brandOnlyTarget(Object.fromEntries(new URLSearchParams(location.searchStr ?? "")));
    if (direct) throw redirect({ href: direct, statusCode: 301 });
    throw redirect({ href: `/cars${location.searchStr ?? ""}`, statusCode: 301 });
  },
});
